import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Table = styled(Box)(_templateObject(), theme("Table"));
var Table$1 = use(Table, "table");

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var TableWrapper = styled(Box)(_templateObject$1(), theme("TableWrapper"));
var TableWrapper$1 = use(TableWrapper, "div");

var index = Object.assign(Table$1, {
  Wrapper: TableWrapper$1
});

export default index;
